<template>
  <v-container class="component_main px-6">
    <v-row v-show="showList"  class="px-0">
      <v-col>
        <h1>Cronogramas
          <span>
              <v-tooltip right>
                <template v-slot:activator="{on, attrs}">
                  <v-btn 
                  color="primary" 
                  icon
                  small
                  @click=modalVideo()
                  v-bind="attrs"
                  v-on="on"  
                  >
                <v-icon small>fa-regular fa-life-ring</v-icon>
              </v-btn>
                </template>
                <span class="px-3 py-1 ma-0"
                    style="
                      border: solid 1px #999;
                      border-radius: 5px;
                      background-color: #fff;
                    ">Ajuda: Como criar o cronograma </span>
              </v-tooltip>
            </span>
        </h1>
        <p>Gerencie as informações dos cronogramas</p>
      </v-col>
      <v-col class="d-flex justify-end">
        <v-btn 
          v-if="userData.PermissaoAcoes.faturamento.includes('addcronograma')"
          color="primary" 
          depressed
          height="30px"
          small 
          to="/faturamento/cronogramas/novocronograma"
        >Novo Cronograma</v-btn>
        <v-tooltip v-else center bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
            outlined
            color="rgb(151 151 151 / 58%)"
            height="40px"
            class="px-2 ml-2"
            depressed
            v-bind="attrs"
            v-on="on"
            >Novo Cronograma</v-btn>
          </template>
          <span class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF;">
            Você não possui permissão para executar esta ação.
          </span>
        </v-tooltip>
      </v-col>
    </v-row>
    <CronogramaFilter
      v-show="showList"
      :filter="filter"
      :prestadores="prestadores"
      :operadoras="listOperadora"
      :responsaveis="listResponsavel"
      :formatDate="(date) => formatDate(date)"
      :parseDate="(date) => parseDate(date)"
      :getOperadoras="(item) => getOperadoras(item)"
      :getResponsaveis="(item) => getResponsaveis(item)"
      :controlResponsavel="controlResponsavel"
      :userData="userData"
      :updateFilter="(flt, page, from) => updateFilter(flt, page, from)"
      :prestadorId="(id) => prestadorSelect(id)"
    />
      <!-- :filterList="(formData) => getList(formData)" -->
    <v-row wrap class="d-flex flex-row">
      <v-col class="col-xs-12 col-sm-12 col-md-12 pa-0">
        <CronogramaList
          v-show="showList"
          :list="filteredList"
          :headers="headers"
          :pagination="pagination"
          :updateFilter="(flt, page, from) => getList(flt, page, from)"
          :filter="filter"
          :selectItem="(id) => goTodetails(id)"
          :totais="totaisCronograma"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import CronogramaList from "@/components/faturamento/cronogramas/CronogramaList";
import CronogramaFilter from "@/components/faturamento/cronogramas/CronogramaFilter";
export default {
  components: {
    CronogramaList,
    CronogramaFilter
  },
  data() {
    return {
      editItem: {},
      filteredList: [],
      controlResponsavel: true,
      showDados: false,
      headers: [
        { text: "Faturamento", value: "dt_faturamento", class: "nowrap_header", sortable: true, align: 'center'},
        { text: "Responsável", value: "owner_username", class: "nowrap_header", sortable: true, align: 'center' },
        { text: "Prestador", value: "prest_nome", class: "nowrap_header", sortable: true, align: 'center'},
        { text: "Ident.", value: "login_prestador", class: "nowrap_header", sortable: true, align: 'center' },
        { text: "Operadora", value: "oper_nome", class: "nowrap_header", sortable: true, align: 'start'},
        { text: "Tipo Guia", width: '90px', value: "tipo_guia", class: "nowrap_header", sortable: true, align: 'start' },
        { text: "Vl. previsto", value: "vl_prev_faturamento", class: "nowrap_header", sortable: true, align: 'center' },
        { text: "Vl. importado", value: "arq_vl_calculado", class: "nowrap_header", sortable: true, align: 'center' },        
        { text: "Vl. conciliado", value: "arq_vl_conciliado", class: "nowrap_header", sortable: true, align: 'center' },
        { text: "Status", value: "status", sortable: false, align: 'center lotes-critica' },
        // { text: "Status", value: "Status" },
      ],
      pagination: {
        limit: 20,
        offset: 1,
        current_page: 1,
      },
      prestadores: [],
      showList: true,
      selectedItem: {},
      totaisCronograma: {
        total_importado: 0,
        total_previsto: 0,
        total_conciliado: 0,
        total_porcem_conciliado: 0
      }
    };
  },
  watch: {
    grupoEconomicoList:{
      deep: true,
      handler() {
        this.prestadores = this.$store.getters["permissions/getPrestadoresByGeco"]();
      }
    },
    listCrono(val) {
      this.filteredList = val;
    },
  },

  computed: {
    ...mapState({
      filter: (state) => state.faturamento.filter,
      grupoEconomico: (state) => state.permissions.grupoEconomico,
      grupoEconomicoList: state =>state.permissions.grupoEconomicoList,
      feriadosList: (state) => state.common.feriadosList,
      listCrono: (state) => state.faturamento.listCrono,
      listCronoLength: (state) => state.faturamento.listCronoLength,
      listOperadora: (state) => state.faturamento.listOperadora,
      listResponsavel: (state) => state.faturamento.listResponsavel,
      detalhesCronograma: (state) => state.faturamento.detalhesCronograma,
      userData: (state) => state.userData.userData,
    }),
  },
  mounted() {
    this.prestadores = this.$store.getters["permissions/getPrestadoresByGeco"]()
    
    let userData = this.$store.state.userData.userData
    this.controlResponsavel = !userData.Permissao.faturamento.includes('gestor')
    let opts = {
          grupoEconomico: this.grupoEconomico,
          limitar: false,
          modulo_operadora: "faturamento"
        }
    this.getResponsaveis(opts)
    this.getOperadoras(opts)
  },
  methods: {
    ...mapActions('faturamento', [
      "getCronogramas",
      "getResponsaveis",
      "getDetalhesCronograma",
      "prestadorSelect",
      "setIdCronograma"
    ]),
    ...mapActions('permissions', [
      "getOperadoras",
    ]),
    updateFilter(filter, page, from) {
      this.$store.commit("faturamento/setFilter", filter, {root:true})
      this.getList(filter, page, from)
    },
    selectItem(item, action) {
      switch (action) {
        case "download":
          this.selectedItem = Object.assign({}, item);
          this.getCronograma(this.selectedItem)
          break;

        case "edit":
          this.selectToEditItem(item, true)
          break;

        case "newCrono":
          this.showList = false;
          break;

        default:
          break;
      }
    },
    modalVideo(){
      let paramModal = {
          codigo: "752630275",
          title: "Como criar o cronograma",
      }
      this.$store.commit('tutorial/abreVideo', paramModal);
    },
     selectToEditItem(item, showForm) {
      if (!item) return;
      this.editItem = { ...item };
      this.$nextTick(() => (this.showList = showForm ? false : this.showList));
    },
    formatDate (date) {
        if (!date) return null
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
    parseDate (date) {
        if (!date) return null
        const [day, month, year] = date.split('/')
        return `${year}-${month}-${day}`
    },
    filterList(formData) {
      let list = Array.from(this.listCrono)
      let newList = [];
      if (formData && list.length) {
        newList = list.reduce((arr, item) => {
          let matchDateStart = Date.parse(formData.dateFormattedI) <= Date.parse(item.dt_faturamento) || !formData.dateFormattedI  
          let matchDateEnd = Date.parse(formData.dateFormattedF) >= Date.parse(item.dt_faturamento) || !formData.dateFormattedF

          if(matchDateStart && matchDateEnd) {
            arr.push(item);
          }
          return arr
        }, [])
      }
      this.filteredList = newList;
    },
    getList(filter, page, from) {
      this.pagination.offset = page? page : 1
      let opts = Object.assign(this.pagination, {grupoEconomico: this.grupoEconomico, limitar: false, complementar: false}, filter)
      opts.from = from
      if( opts.operadora_ans_id != null && typeof [] === typeof opts.operadora_ans_id){
        return
      }
      this.getCronogramas(opts).then(response=> {
        this.filteredList = Array.from(this.listCrono)
         if (!response || response.isAxiosError || response.error) {
          this.$store.commit("hideLoader")
          return
        }
        let { total_pages, current_page, total_importado, total_previsto, total_conciliado, total_porcem_conciliado  } = response
        this.pagination.total_pages = total_pages
        this.pagination.offset = current_page
        this.pagination.current_page = current_page
        this.totaisCronograma.total_importado = total_importado
        this.totaisCronograma.total_previsto = total_previsto
        this.totaisCronograma.total_conciliado = total_conciliado
        this.totaisCronograma.total_porcem_conciliado = total_porcem_conciliado
        })
    },
    saveItem(formData) {
      let opts = {}
      if(formData == null){
        opts = Object.assign(this.pagination, { grupoEconomico: this.grupoEconomico, limitar: false }, this.filter)
        this.getCronogramas(opts).then(()=>this.showList = true)
        return
      }
      formData.grupo_economico = this.grupoEconomico

      let acao = formData.id ? "updatecronograma" : "addcronograma"
      let payload = formData

      var data = {
        query: 
        [{
          "Modulo": "faturamento",
          "Acao": acao,
          "Payload": payload
        }]
      };

      this.$store.dispatch("request/doRequest", data).then((response) => {
        if (!response || response.isAxiosError || !response.sucesso) {
          this.$store.commit("hideLoader");
          return;
        }
        let paramModal = {
          type: "success",
          title: "Sucesso!",
          message: response.mensagem,
          callback: () => {
            this.getCronogramas(opts).then(()=>this.showList = true)
            
          },
          btConfirm: { name: "Ok", show: true },
        }
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
      })
    },
    deleteCronograma(id) {
      let obj = {
        query: [
          {
            Modulo: "Portal",
            Acao: "deletecronograma",
            Payload: {
              Id: id,
            },
          },
        ],
      };
      this.$store.dispatch("request/doRequest", obj)
    },
    goTodetails(id) {
      let url  = '/faturamento/cronogramas/dadosdocronograma/'+id
      this.$router.push(url)
      this.setIdCronograma(id)
    }
  },
};
</script>
<style>
</style>